export default {
    "Bem vindo(a) ao": "Bienvenido(a) a",
    "Entre com suas credenciais": "Ingrese sus credenciales",
    "do Ginfo abaixo": "de Ginfo a continuación",
    "Empresa": "Empresa",
    "empresa_login": "Empresa",
    "Selecione a empresa": "Seleccione la empresa",
    "E-mail": "Correo electrónico",
    "Senha": "Contraseña",
    "Lembrar de mim": "Recordarme",
    "Entrar": "Ingresar",
    "Solicite seu acesso": "Solicite su acceso",

    "Portugues": "Portugués",
    "Mercosul": "Mercosur",
    "Ingles": "Inglés",
    "Frances": "Francés",
    "Alemao": "Alemán",
    "Holandes": "Holandés",

    'Carregando': 'Cargando',
    'TODOS': 'TODO',
    'BELGIUM': 'BÉLGICA',
    'GERMANY': 'ALEMANIA',
    'SELECIONE_O_PAIS': 'Seleccione el país',
    'PAIS': 'País',
    "inicio": "Inicio",
    "bem_vindo": "Bienvenido(a) a",
    "ginfo_analytics": "GINFO Analytics",
    "informacoes_inteligentes": "Información inteligente para decisiones más rápidas, seguras y estratégicas",
    "acessados_recentemente": "Accedidos recientemente",
    "buscar_relatorio": "Buscar informe",
    "nenhum_relatorio_encontrado": "No se encontraron informes.",
    "acesso_power_bi": "Acceso a Power BI",
    "ajuda": "Ayuda",
    "sair": "Salir",
    "agora": "ahora",
    "ha": "hace",
    "minutos": "min",
    "horas": "h",
    "ontem": "ayer",
    "dias": "días",
    "semanas": "semanas",
    "buscar_abrir_relatorio": "Buscar y abrir informe",
    "mostrar_senha": "Mostrar contraseña",
    "ocultar_senha": "Ocultar contraseña",
    "esqueceu_senha": "¿Olvidó su contraseña?",
    "login_frase_inicio": "Las mejores decisiones comienzan con",
    "login_frase_destaque": "la información correcta",
    "login_frase_2": "el momento adecuado",
    "login_frase_3": "el lugar adecuado",
    "recarregar_relatorio": "Actualizar informe",
    "fechar_aba": "Cerrar pestaña",
    "horarios_atualizacao": "Horarios de actualización",
    "tutorial_desta_tela": "Tutorial de esta pantalla",
    "fechar": "Cerrar",
    "carregando_tutorial": "Cargando tutorial...",
    "tutorial_indisponivel": "Tutorial no disponible para esta pantalla por ahora.",
    "passo": "Paso"

}